import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { Skeleton } from './Skeleton'

const AVATAR_SIZE = 50

export const MessageItemSkeleton: React.FC = () => {
  const theme = useTheme()
  const styles = getStyle(theme)

  return (
    <View style={styles.container}>
      <Skeleton width={AVATAR_SIZE} height={AVATAR_SIZE} borderRadius={AVATAR_SIZE / 2} />
      <View style={styles.content}>
        <View style={styles.header}>
          <Skeleton width="40%" height={16} borderRadius={4} />
          <Skeleton width={60} height={12} borderRadius={4} />
        </View>
        <Skeleton width="70%" height={14} borderRadius={4} style={styles.messageSkeleton} />
      </View>
    </View>
  )
}

export const MessageItemSkeletonList: React.FC<{ count?: number }> = ({ count = 8 }) => {
  return (
    <View>
      {Array.from({ length: count }).map((_, index) => (
        <MessageItemSkeleton key={index} />
      ))}
    </View>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: theme.spacing.md,
      paddingHorizontal: theme.spacing.lg,
    },
    content: {
      flex: 1,
      marginLeft: theme.spacing.md,
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing.xs,
    },
    messageSkeleton: {
      marginTop: theme.spacing.xs / 2,
    },
  })

